import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/pathum-danthanarayana-t8TOMKe6xZU-unsplash.jpg";
import projImg2 from "../assets/img/python-programming-language-web-development-coding-concept-python-programming-language-web-development-coding-concept-101102785.jpg";
import projImg3 from "../assets/img/istockphoto-1371339413-170667a.jpg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Build to Learn ",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "way to Learn",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "Build to Learn",
      description: "Design & Development",
      imgUrl: projImg3,
    },
    {
      title: "way on learning",
      description: "Design & Development",
      imgUrl: projImg1,
    },
    {
      title: "Build to learn ",
      description: "Design & Development",
      imgUrl: projImg2,
    },
    {
      title: "way on learning",
      description: "Design & Development",
      imgUrl: projImg3,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>you can also see my twitter account : <a href="https://twitter.com/SonuRoy96000?t=ua1mJmfqvE-Vs8rsQpSFEg&s=08">Twitter </a> <br/>you can also see my linkdin profile at:<a href="https://www.linkedin.com/in/sonu-roy-4a8b98215"> linkdin</a></p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      </Tab.Pane>

                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
